module.exports = __webpack_public_path__ + "static/media/level-five.bfa06673.svg";